import { Box, IconButton, InputAdornment, Typography, useTheme } from "@mui/material"
import LogoToranja from "assets/images/LogoToranja.svg"
import Logo from "assets/logo.svg"
import { useFormik } from "formik"
import { useAuth } from "hooks/useAuth"
import { useState } from "react"
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md"
import { Input, LoadingButton } from "shared"
import * as yup from "yup"

const validationSchema = yup.object().shape({
  username: yup.string().required("Digite o seu nome de usuário"),
  password: yup.string().required("Digite a sua senha"),
})

const Login = () => {
  const theme = useTheme()
  const { signIn } = useAuth()
  const [hidePass, setHidePass] = useState(true)

  const initialValues = {
    username: "",
    password: "",
  }

  const formik = useFormik({
    onSubmit: signIn,
    initialValues,
    validationSchema,
  })

  return (
    <main style={{ height: "100vh" }}>
      <Box display="flex" height="100%">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="50%"
          sx={{ display: ["none", "none", "flex"] }}
          bgcolor={theme.palette.secondary.light}
        >
          <img src={LogoToranja} alt="LogoToranja" width="60%" />
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          m="0 auto"
          sx={{ width: ["100%", "50%"] }}
          bgcolor="#fff"
        >
          <Box display="flex" justifyContent="center" alignItems="center" height="80px">
            <img src={Logo} alt="Logo" height="40px" />
          </Box>

          <Box
            component="form"
            onSubmit={formik.handleSubmit}
            display="flex"
            flexDirection="column"
            m="2rem"
            width="100%"
            p="0 2rem"
            maxWidth="25rem"
            height="100%"
            justifyContent="center"
            alignItems="center"
            gap="1rem"
            noValidate
          >
            <Typography fontSize="1.8rem" fontFamily="Inter" fontWeight={500}>
              Olá, bem-vindo ao Toranja
            </Typography>
            <Input
              fullWidth
              name="username"
              label="Usuário"
              value={formik.values.username}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                (formik.touched.username || formik.submitCount > 0) && !!formik.errors.username
              }
              helperText={
                (formik.touched.username || formik.submitCount > 0) && formik.errors.username
              }
            />

            <Input
              fullWidth
              name="password"
              type={hidePass ? "password" : "text"}
              label="Senha"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                (formik.touched.password || formik.submitCount > 0) && !!formik.errors.password
              }
              helperText={
                (formik.touched.password || formik.submitCount > 0) && formik.errors.password
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Mostrar/Ocultar Senha"
                      onClick={() => setHidePass(!hidePass)}
                    >
                      {hidePass ? <MdOutlineVisibilityOff /> : <MdOutlineVisibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <LoadingButton loading={formik.isSubmitting} type="submit" fullWidth>
              Entrar
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </main>
  )
}

export default Login
